import Layout from "../../../../src/components/layout";
import SEO from "../../../../src/components/seo";
import { Images as images } from "../../../../src/data/assets";
import * as React from 'react';
export default {
  Layout,
  SEO,
  images,
  React
};